/** Prefixo das chaves sb-*-auth-token no localStorage (depende do ref do projeto na URL). */
export function getSupabaseAuthStoragePrefix() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL || "";
  const m = url.match(/https?:\/\/([a-z0-9]+)\.supabase\.co/i);
  const ref = m?.[1];
  return ref ? `sb-${ref}` : null;
}

export function getSupabaseAuthLocalStorageKeys() {
  const p = getSupabaseAuthStoragePrefix();
  if (!p) return [];
  return [`${p}-auth-token`, `${p}-auth-token-code-verifier`];
}
